/* eslint-disable */
import { Button, Checkbox, Flex, Popover, Radio, Space, Dropdown,Modal,message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  EditOutlined,
  SolutionOutlined,
  OneToOneOutlined,
  MenuOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
  PlusOutlined
} from "@ant-design/icons";

import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable } from "@/hocComponents";
import moment from "moment";
import AddModal from "./component/AddModal";
import ResetModal from "./component/ResetModal";
export default function TypeJob() {
  const addModalRef = useRef(null);
  const EditModalRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const childRef = useRef();
  const [tableLoading, setTableLoading] = useState(false);
  const [tableList, setTableList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //调用子组件showModal方法
  const showModalAdd = () => {
    addModalRef.current?.setModelAdd();
  };
  const showModalThree = () => {
    if (
      childRef.current &&
      typeof childRef.current.clearInputs === "function"
    ) {
      childRef.current.clearInputs();
      childRef.current.newListFun();
    }
  };

  const handleMenuClick = async (e, record) => {
    if (e.key === "reset") {
      EditModalRef.current?.open(record);
    }
    if (e.key === "delete") {
      Modal.confirm({
        className: "commonModal",
        title: "Complete Request",
        icon: <ExclamationCircleOutlined />,
        content: <span>Are you sure to delete this data?</span>,
        okText: "Sure",
        cancelText: "Cancel",
        async onOk() {
          setLoading(true);
          try {
            const params = { id: record.id };
            const response = await http.get(api.getGlTransRulesDelete, { params });
            if (response.code === "1") {
              message.success("Successfully deleted.");
            getTableListFn(pagination.current, pagination.pageSize, tableHead);
            } else {
              message.error(response?.msg || "Delete failed.");
            }
          } catch (error) {
            message.error("An error occurred. Please try again.");
          } finally {
            setLoading(false);
          }
        },

        onCancel() {},
        style: {
          top: "40%",
        },
      });
    }

  };

  // table
  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);
  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("ModifyGlTransRules") ||
          commonFn.btnAuthorityFlag("DeleteGlTransRules")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("ModifyGlTransRules") && {
                  key: "reset",
                  icon: (
                    <EditOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Modify Gl Trans Rules</div>,
                },
                commonFn.btnAuthorityFlag("DeleteGlTransRules") && {
                  key: "delete",
                  icon: (
                    <SolutionOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Delete Gl Trans Rules</div>,
                },
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        ),
    },
    // {
    //   title: "Name",
    //   dataIndex: "name",
    //   key: "name",
    //   hidden: false,
    //   width: 100,
    //   align: "center",
    //   sortterMultiple: 2,
    //   render: (text, record) => {
    //     const style = {};
    //     if (record.level === 1) {
    //       style.fontWeight = "bold";
    //     }
    //     return <div style={style}>{text}</div>;
    //   },
    // },
  {
  title: "Name",
  dataIndex: "name",
  key: "name",
  width: 200,
  align: "left",
  render: (text, record) => {
    return (
     <span   style={{ fontWeight: record.isRoot ? 700 : 400,}} >
        {text}
      </span>
    );
  },
},
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      align: "center",
      hidden: false,
      maxWidth: 80,
    },
    {
      title: "Rules",
      dataIndex: "rules",
      key: "rules",
      align: "center",
      hidden: false,
      width: 300,
    },
     {
      title: "Sign",
      dataIndex: "sign",
      key: "sign",
      align: "center",
      hidden: false,
      width: 100,
       render: (value) => (value === 1 ? "Negative" : "Positive"),
    },
      {
      title: "Module",
      dataIndex: "module",
      key: "module",
      align: "center",
      hidden: false,
    },
    {
      title: "Create By",
      dataIndex: "createByName",
      key: "createByName",
      align: "center",
       width: 100,
      hidden: false,
    },
    {
      title: "Create Time",
      dataIndex: "createTime",
      key: "createTime",
      align: "center",
      hidden: false,
       render: (text, record, index) =>
           text ? moment(text).format("MM/DD/YYYY HH:mm") : " ",
    },
     {
      title: "Update By",
      dataIndex: "updateByName",
      key: "updateByName",
      align: "center",
       width: 100,
      hidden: false,
    },
    {
      title: "Update Time",
      dataIndex: "updateTime",
      key: "updateTime",
      align: "center",
      hidden: false,
      render: (text, record, index) =>
       text ? moment(text).format("MM/DD/YYYY HH:mm") : " ",
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 处理选项变化
  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);

    const response = await http.get(api.getGlTransRulesList);
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    // const list = (response.data || []).map((item, index) => ({
    //   ...item,
    //   key: item.id,
    // }));
    // setTableList(list);
const addKey = (list = [], isRoot = false) => {
  return list.map((item) => ({
    ...item,
    key: item.id,
    isRoot,
    children: item.children?.length
      ? addKey(item.children, false)
      : undefined,
  }));
};
const list = addKey(response.data || [], true);
setTableList(list);
    setTableLoading(false);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          {(commonFn.btnAuthorityFlag("Add") && (
            <Space size="large">
              <Button className="btnNew" onClick={showModalAdd}>
                <PlusOutlined />  
                New
              </Button>
            </Space>
          )) ||
            null}
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        tableCss="maintenanceTable"
        rowKey="id"
      />
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn();
        }}
      />

      <ResetModal
        ref={EditModalRef}
        onSuccess={() => {
          getTableListFn();
        }}
      />
    </div>
  );
}
